import { AxiosRequestConfig } from 'axios';
import { getApiv14 } from './apiv14Setup';

export type PriceUpdateStatus =
  | 'updated'
  | 'already_running'
  | 'disabled'
  | 'rates_unavailable';

export interface PriceUpdateResponse {
  result: {
    status: PriceUpdateStatus;
    rateDate?: string;
    itemsUpdated: number;
    licencesUpdated: number;
    conflicts: number;
  };
}

/** Admin only. Updates every quotable item and licence that has a primary currency. */
export const runPriceUpdate = (config?: AxiosRequestConfig) =>
  getApiv14().post<PriceUpdateResponse>(
    '/store/prices/update',
    undefined,
    config
  );
